module.exports = __webpack_public_path__ + "media/images/web_suite/feature_icons/icon_quiz_flashcards-09252606300efb2ffda8a40890f0bafd.png";